import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@cropler/ui-kit';

import stylesModal from '../../../styles/modal.module.scss';
import { fieldsApi, useDeleteFieldMutation } from '../../../store/api/fields';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const DeleteFieldForm = ({ t, editedField = { id: '', name: '' }, closeModal }) => {
  const dispatch = useDispatch();
  const [deleteField, { isSuccess: isDeleteFieldSuccess }] = useDeleteFieldMutation();

  const onDeleteField = () => {
    deleteField({ fieldId: editedField.id });
    closeModal();
  };

  useEffect(() => {
    if (isDeleteFieldSuccess) {
      setTimeout(() => {
        dispatch(fieldsApi.util.resetApiState());
      });
    }
  }, [isDeleteFieldSuccess]);

  return (
    <>
      <p dangerouslySetInnerHTML={{__html: t('fields.deleteText', { name: editedField.name })}}></p>
      <div className={stylesModal.modalNav}>
        <Button type="secondary" onClick={closeModal}>
          {t('actions.cancel')}
        </Button>
        <Button type="danger" icon={<CroplerIcon name="remove" />} onClick={() => onDeleteField()}>
          {t('actions.delete')}
        </Button>
      </div>
    </>
  );
};

export default DeleteFieldForm;
